import React from 'react';
import { Select } from '../../../../../../../styleguide';
import AceEditor from 'react-ace';
import { Input, Switch } from 'antd';
import 'brace/theme/monokai';
import 'brace/mode/javascript';


const { Option } = Select;

const CustomJS = ({
  value,
  settingsTitle,
  settingKey,
  updateSetting,
  neutralStateDisabled,
  allSettings
}) => {
  return (
    <>
    <h5>Custom Javascript</h5>
    <div style={{ width: '100%', padding: '0 5px', position: 'relative' }}>
      <AceEditor
        value={value}
        mode='javascript'
        theme='monokai'
        readOnly={neutralStateDisabled || false}
        width='100%'
        height="200px"
        focus={!neutralStateDisabled}
        onChange={(value) => updateSetting(settingKey, value)}
        style={{ opacity: neutralStateDisabled ? 0.5 : 1 }}
      />
      {neutralStateDisabled && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            cursor: 'not-allowed',
            zIndex: 1
          }}
        />
      )}
    </div>
    <div style={{ marginTop: '10px', padding: '0 5px', display: 'flex', alignItems: 'flex-start' }}>
      <Switch
        checked={(allSettings && allSettings.requiredConsentDoNotTriggerUserActionComplete) || false}
        disabled={neutralStateDisabled || false}
        onChange={(checked) => updateSetting('requiredConsentDoNotTriggerUserActionComplete', checked)}
      />
      <span style={{ marginLeft: '10px', textAlign: 'right', flex: 1 }}>Do not trigger userActionComplete event</span>
    </div>
  </>
  );
};


export default CustomJS;